(() => {
  'use strict';
  const mobile = matchMedia('(max-width: 899px)');
  const header = document.querySelector('.dama-header');
  const menu = header?.querySelector('.dama-mobile-menu');
  const burger = header?.querySelector('.header__burger');
  const panels = [...(menu?.querySelectorAll('[data-dama-mobile-panel]') || [])];
  const triggers = [...(menu?.querySelectorAll('[data-dama-mobile-open]') || [])];
  let lastTrigger = null;
  function showPanel(name, focus = true) {
    const panel = panels.find(node => node.dataset.damaMobilePanel === name);
    if (!panel) return;
    panels.forEach(node => { node.hidden = node !== panel; });
    triggers.forEach(node => node.setAttribute('aria-expanded', String(node.dataset.damaMobileOpen === name)));
    menu.scrollTop = 0;
    if (focus) (name === 'main' ? lastTrigger : panel.querySelector('[data-dama-mobile-back]'))?.focus({preventScroll: true});
  }
  triggers.forEach(trigger => trigger.addEventListener('click', event => {
    if (!mobile.matches || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault();
    lastTrigger = trigger;
    showPanel(trigger.dataset.damaMobileOpen);
  }));
  menu?.querySelectorAll('[data-dama-mobile-back]').forEach(button => button.addEventListener('click', () => showPanel('main')));
  const languageTrigger = menu?.querySelector('[data-dama-menu="dama-mobile-language-menu"]');
  const languagePanel = document.getElementById('dama-mobile-language-menu');
  function closeMobileLanguage() {
    languageTrigger?.setAttribute('aria-expanded', 'false');
    if (languagePanel) languagePanel.hidden = true;
  }
  burger?.addEventListener('click', () => queueMicrotask(() => {
    closeMobileLanguage();
    showPanel('main', false);
    if (burger.getAttribute('aria-expanded') === 'true') triggers[0]?.focus({preventScroll: true});
    else menu?.querySelectorAll('details[open]').forEach(node => { node.open = false; });
  }));
  header?.addEventListener('click', event => {
    if (event.target.closest('[data-search-toggle]') && burger?.getAttribute('aria-expanded') === 'true') burger.click();
  }, true);
  mobile.addEventListener('change', () => {
    if (!mobile.matches && burger?.getAttribute('aria-expanded') === 'true') burger.click();
  });

  menu?.addEventListener('keydown', event => {
    if (!mobile.matches || event.key !== 'Escape' || languageTrigger?.getAttribute('aria-expanded') !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    closeMobileLanguage();
    languageTrigger.focus({preventScroll:true});
  });

  const modals = [...document.querySelectorAll('#filter.dama-mobile-filter, #bundle-offers, #continue-shopping.dama-product-added')]
    .map(node => ({node, active: false, done: false, returnFocus: null}));
  if (!modals.length) return;
  let currentModal = null;
  let cartCountRead = 0;
  const refreshCartCount = () => {
    const read = ++cartCountRead;
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js', {method: 'GET', credentials: 'same-origin', cache: 'no-store'})
      .then(response => {
        if (!response.ok) throw new Error('Cart count unavailable');
        return response.json();
      })
      .then(cart => {
        const count = cart.item_count;
        if (read !== cartCountRead || !Number.isInteger(count) || count < 0) return;
        document.querySelectorAll('[data-cart-button]').forEach(button => {
          const counter = button.querySelector('[data-dama-cart-count]');
          if (counter) counter.textContent = String(count);
          const label = button.dataset.damaCartLabel;
          if (label) button.setAttribute('aria-label', label.replace('__COUNT__', String(count)));
          button.classList.toggle('active', count > 0);
        });
      })
      .catch(() => {});
  };
  const visible = node => Boolean(node?.isConnected && !node.closest('[hidden], [inert]') && node.getClientRects().length);
  const controls = state => [...state.node.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]')]
    .filter(node => node.getAttribute('tabindex') !== '-1' && visible(node));
  const fallbackOpener = state => state.node.id === 'filter'
    ? document.querySelector('[data-popup-open="filter"]')
    : document.querySelector('.form--product button[type="submit"], .form--product input[type="submit"]');
  const focusTarget = state => {
    const confirmation = state.node.id === 'continue-shopping'
      ? state.node.querySelector('#dama-product-added-title')
      : state.done ? state.node.querySelector('#dama-bundle-success-title') : null;
    return visible(confirmation) ? confirmation : state.node.querySelector('.popup__content-header [data-popup-close]') || controls(state)[0];
  };
  const setExpanded = (state, expanded) => {
    if (state.node.id === 'filter') state.returnFocus?.setAttribute('aria-expanded', String(expanded));
  };
  document.addEventListener('submit', event => {
    if (!event.target.matches('.form--product')) return;
    modals.filter(item => item.node.id !== 'filter').forEach(state => {
      state.returnFocus = visible(event.submitter) ? event.submitter : fallbackOpener(state);
    });
  }, true);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-popup-open]');
    const state = modals.find(item => item.node.id === opener?.getAttribute('data-popup-open'));
    if (!state || state.active) return;
    if (visible(opener)) state.returnFocus = opener;
    else if (!visible(state.returnFocus)) {
      const focused = document.activeElement;
      state.returnFocus = visible(focused) && !state.node.contains(focused) && focused !== document.body ? focused : fallbackOpener(state);
    }
  }, true);
  const syncModalFocus = state => {
    const isOpen = state.node.classList.contains('popup--show');
    const isDone = isOpen && state.node.classList.contains('is-done');
    const opening = isOpen && !state.active;
    const closing = !isOpen && state.active;
    const stateChanged = isDone !== state.done;
    state.active = isOpen;
    state.done = isDone;
    if (opening) {
      currentModal = state;
      if (!visible(state.returnFocus)) state.returnFocus = fallbackOpener(state);
      setExpanded(state, true);
    }
    if (isOpen && (opening || stateChanged)) focusTarget(state)?.focus({preventScroll: true});
    if (isOpen && ((state.node.id === 'continue-shopping' && opening) || (state.node.id === 'bundle-offers' && isDone && stateChanged))) refreshCartCount();
    if (closing) {
      setExpanded(state, false);
      if (currentModal === state) currentModal = modals.findLast(item => item.active) || null;
      if (currentModal) focusTarget(currentModal)?.focus({preventScroll: true});
      else {
        const opener = visible(state.returnFocus) ? state.returnFocus : fallbackOpener(state);
        if (visible(opener)) opener.focus({preventScroll: true});
      }
    }
  };
  modals.forEach(state => {
    new MutationObserver(() => syncModalFocus(state)).observe(state.node, {attributes: true, attributeFilter: ['class']});
    syncModalFocus(state);
  });
  document.addEventListener('focusin', event => {
    if (currentModal?.active && !currentModal.node.contains(event.target)) focusTarget(currentModal)?.focus({preventScroll: true});
  });
  document.addEventListener('keydown', event => {
    if (!currentModal?.active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      currentModal.node.querySelector('.popup__content-header [data-popup-close]')?.click();
      return;
    }
    if (event.key !== 'Tab') return;
    const nodes = controls(currentModal), first = nodes[0], last = nodes[nodes.length - 1];
    if (!first) return;
    if (!currentModal.node.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

// ARCH-35: only the exact existing collection destination, once per viewport menu.
(() => {
  'use strict';
  const header = document.querySelector('.dama-header');
  if (!header) return;
  const here = new URL(window.location.href);
  const collectionPath = value => {
    try {
      const url = new URL(value, document.baseURI);
      if (url.origin !== here.origin) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/.test(url.pathname)) return null;
      return url.pathname.replace(/\/$/, '');
    } catch (_) {
      return null;
    }
  };
  const current = collectionPath(here.href);
  if (!current) return;
  const isCurrent = link => {
    const href = link.getAttribute('href');
    if (!href || /^[#?]/.test(href.trim()) || link.hasAttribute('data-dama-mobile-open')) return false;
    return collectionPath(link.href) === current;
  };
  const markFirst = selectors => {
    for (const selector of selectors) {
      const link = [...header.querySelectorAll(selector)].find(isCurrent);
      if (!link) continue;
      link.setAttribute('aria-current', 'page');
      break;
    }
  };
  markFirst([
    '#dama-mega-dresses .dama-mega__columns a[href]',
    '.dama-header__left .dama-nav-group > a[href]',
    '#dama-mega-dresses .dama-mega__bottom a[href]',
    '#dama-mega-years a[href]'
  ]);
  markFirst([
    '#dama-mobile-dresses .dama-mobile-menu__groups a[href]',
    '#dama-mobile-dresses .dama-mobile-menu__bottom a[href]',
    '#dama-mobile-years a[href]'
  ]);
})();
